<template>
  <section class="message__text">
    <slot />
    <div v-html="computedContent" />
  </section>
</template>

<script>
export default {
  props: {
    content: { type: String, default: undefined }
  },
  computed: {
    computedContent() {
      if (this.content.includes('href') && !this.content.includes('tel:')) {
        return this.content.replace(/(href=".*?")/g, '$1 target="_blank"')
      }

      return this.content
    }
  }
}
</script>

<style lang="scss">
.message__text {
  max-width: max-content;

  .message__sender--member & {
    color: var(--gl-color-shades-white);
    fill: var(--gl-color-shades-white);
  }

  .message__sender--member .message__content--reply & {
    color: var(--gl-color-shades-gray-10);
  }

  .mention {
    color: var(--gl-color-shades-yellow-50);
  }
}
</style>
